var DEFAULT_RANGE_OPTIONS = [10, 25, 50, 100, 250];

export { DEFAULT_RANGE_OPTIONS };
